import { useMutation } from "react-query";
import { handleModalStatus } from "../../../../../utils/handleModalStatus";

type FormMutationProps = {
  showModal: any;
  service: any;
  onCloseModalSuccess?: () => void;
  onCloseModalError?: () => void;
  onCloseModalUpdate?: () => void;
  onCloseModalDelete?: () => void;
  onSuccess?: () => void;
};

function useFormMutation({
  showModal,
  service,
  onCloseModalSuccess,
  onCloseModalError,
  onCloseModalUpdate,
  onCloseModalDelete,
  onSuccess,
}: FormMutationProps) {
  const {
    mutateAsync: createMutation,
    isLoading: createMutationLoading,
    isError: createMutationError,
  } = useMutation({
    mutationFn: service.create,
    onSuccess: (res: any) => {
      if (res?.response?.status > 299) {
        throw handleModalStatus({
          type: "error",
          msgOnError:
            res?.response?.descricao ??
            res?.response?.data?.descricao ??
            "O arquivo anexo não foi criado. Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.",
          showModal: showModal,
          onCloseModal: onCloseModalError,
        });
      }

      handleModalStatus({
        type: "success",
        msgOnSuccess: "Arquivo anexo criado com sucesso.",
        showModal: showModal,
        onCloseModal: onCloseModalSuccess,
      });
      onSuccess && onSuccess();
    },
  });

  const {
    mutateAsync: updateMutation,
    isLoading: updateMutationLoading,
    isError: updateMutationError,
  } = useMutation({
    mutationFn: service.update,
    onSuccess: (res: any) => {
      if (res?.response?.status > 299) {
        throw handleModalStatus({
          type: "error",
          msgOnError:
            res?.response?.descricao ??
            res?.response?.data?.descricao ??
            "O arquivo anexo não foi editado. Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.",
          showModal: showModal,
          onCloseModal: onCloseModalError,
        });
      }

      handleModalStatus({
        type: "success",
        msgOnSuccess: "Arquivo anexo editado com sucesso.",
        showModal: showModal,
        onCloseModal: onCloseModalUpdate,
      });
      onSuccess && onSuccess();
    },
  });

  const { mutateAsync: deleteMutation } = useMutation({
    mutationFn: service.delete,
    onSuccess: (res: any) => {
      if (res?.response?.status > 299) {
        throw res;
      } else {
        onSuccess && onSuccess();
        return res;
      }
    },
  });

  const { mutateAsync: updateStatusMutation } = useMutation({
    mutationFn: service.updateStatus,
    onSuccess: (res: any) => {
      if (res?.response?.status > 299) {
        throw res;
      } else {
        onSuccess && onSuccess();
        return res;
      }
    },
  });

  return {
    createMutationLoading,
    createMutationError,
    createMutation,
    deleteMutation,
    updateMutationError,
    updateMutationLoading,
    updateMutation,
    updateStatusMutation,
  };
}
export default useFormMutation;
